export default __webpack_public_path__ + "static/guarranted-1da3c2070b6ea248952fa11de88a6736.gif";